import { TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { mergeSx } from 'design-system';
import { DEFAULT_STRING_DELIMITER } from 'services/api-constants';
import { getFieldControlSx } from '../fieldStyles';
import type { FieldRendererProps } from '../types';

export function MultiselectField({
  field,
  className,
  sx,
  hasWhiteFields = false,
  isDisabled,
  isReadOnly,
  autoFocus,
  onChange,
}: FieldRendererProps) {
  return (
    <Autocomplete
      multiple
      readOnly={isReadOnly}
      className={className}
      sx={mergeSx({ marginBottom: 1, maxWidth: 600 }, getFieldControlSx(hasWhiteFields, sx))}
      id={field.id.toString()}
      options={field.selectOptions}
      getOptionLabel={(o) => o.label}
      disabled={isDisabled}
      filterSelectedOptions
      value={field.selectOptions.filter(
        (o) => o.value && field.value.split(DEFAULT_STRING_DELIMITER).includes(o.value),
      )}
      onChange={(_, options) => {
        const values = options.map((option) => option.value);
        const value = values.join(DEFAULT_STRING_DELIMITER);
        onChange(value, values);
      }}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          {option.label}
        </li>
      )}
      renderInput={(props) => (
        <TextField
          {...props}
          variant="outlined"
          margin="dense"
          autoFocus={autoFocus}
          fullWidth
          label={field.label}
          required={field.required}
        />
      )}
    />
  );
}
